export enum Status {
  None = 0,       // No Color
  Completed = 1,  // Green
  InProcess = 2,  // Yellow
  Alert = 3,      // Red
  NoStatus = 4,   // Grey
  Cancelled = 5,   // Grey
}
